import { ChevronsUpDown, Search, X } from 'lucide-react';
import { type ComponentProps } from 'react';

import { cx } from '@/lib/cx';
import { estiloCampo } from '@/ui/primitives/estilos';

interface GatilhoProps extends ComponentProps<'button'> {
  aberto: boolean;
  texto: string;
  apagado: boolean;
  comLimpar: boolean;
  /** `sm`: compacto, para barras e linhas densas (como o Button `sm`). */
  tamanho?: 'md' | 'sm';
}

export function Gatilho({
  aberto,
  texto,
  apagado,
  comLimpar,
  tamanho = 'md',
  className,
  ...resto
}: GatilhoProps) {
  return (
    <button
      type="button"
      role="combobox"
      aria-expanded={aberto}
      aria-haspopup="listbox"
      className={cx(
        estiloCampo,
        'flex h-controle items-center justify-between gap-2 text-left',
        tamanho === 'sm' && 'h-controle-sm px-2.5 text-sm',
        apagado && 'text-texto-fraco',
        comLimpar && 'pr-14',
        className,
      )}
      {...resto}
    >
      <span className="truncate">{texto}</span>
      <ChevronsUpDown className="size-4 shrink-0 text-texto-fraco" aria-hidden />
    </button>
  );
}

export function CampoBusca(props: ComponentProps<'input'>) {
  return (
    <div className="flex items-center gap-2 border-b border-borda px-2.5">
      <Search className="size-4 shrink-0 text-texto-fraco" aria-hidden />
      <input
        role="combobox"
        aria-expanded="true"
        aria-autocomplete="list"
        placeholder="Digite para buscar"
        className="h-10 w-full bg-transparent text-base outline-none placeholder:text-texto-fraco"
        {...props}
      />
    </div>
  );
}

export function BotaoLimpar({ rotulo, aoLimpar }: { rotulo: string; aoLimpar: () => void }) {
  return (
    <button
      type="button"
      aria-label={rotulo}
      onClick={aoLimpar}
      className="absolute right-8 top-1/2 grid size-6 -translate-y-1/2 place-items-center rounded-pilula text-texto-fraco transition-colors duration-[var(--duracao-rapida)] hover:bg-superficie-hover hover:text-texto"
    >
      <X className="size-3.5" aria-hidden />
    </button>
  );
}
